var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-default-app-bar',{attrs:{"filterable":"","filters":_vm.filters,"back-to":_vm.rotaVoltar}},[_vm._v(" Veiculos ")])
}
var staticRenderFns = []

export { render, staticRenderFns }